module.exports = __webpack_public_path__ + "static/media/en.689275cd.png";